// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__15Pmi","controls":"styles_controls__2eRz5","select":"styles_select__1nEkl","text":"styles_text__3KOFj"};